class CompetionViewer extends FormValidation {
    constructor() {
        super();
        this.quizWrap = this.querySelector('.tmw-landing-page__wrapper');
        this.formWrap = this.querySelector('.tmw-success-form-wrap');
        this.viewer = this.querySelector('.tmw-landing-page__competition-viewer');
        this.viewerImg = this.querySelector('.tmw-landing-page__competition-image');
        this.beginBtn = this.querySelector('.tmw-landing-page__competition-controls .competition-begin-btn');
        this.viewerInstruction = this.querySelector('.tmw-landing-page__competition-active-instr');
        this.timerOutput = this.querySelector('.tmw-landing-page__competition-timer');
        this.instructionTitle = this.querySelector('.tmw-landing-page__competition-description h2');
        this.defaultMsg = this.instructionTitle.innerHTML;
        this.limit = 1;
        this.seconds = 60;
        this.position = { x: 0, y: 0 };
        this.isDragging = false;
        this.dragStart = { x: 0, y: 0 };
        this.isZoomed = false;
        this.scale = 1.0;
        this.containerWidth = this.viewer.offsetWidth;
        this.containerHeight = this.viewer.offsetHeight;
        this._onPointerDown = null;
        this._onPointerMove = null;
        this._onPointerUp = null;
        this._onPointerLeave = null;
    }
    connectedCallback() {
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.beginBtn.addEventListener('click', this.startComp.bind(this));
    }
    startComp() {
        let timer;
        let foundItems = 0;
        const maxItems = this.viewer.getAttribute('data-max-items');
        const viewerProducts = this.querySelectorAll('.tmw-landing-page__competition-entry');
        const viewerKeyItems = this.querySelectorAll('.tmw-landing-page__competition-key-entry');
        this.isZoomed = true;
        this.viewerImg.classList.remove('tmw-landing-page__competition-image--fitted');
        this.viewerImg.classList.add('tmw-landing-page__competition-image--zoomed');
        this.scale = 2;
        this.updatePosition(0, 0);
        let buttonStatus = this.beginBtn.getAttribute('data-attempted');
        this.viewerInstruction.setAttribute('data-viewer-state', 'active');
        // Resets //
        this.querySelector('.tmw-landing-page__competition-description p').setAttribute('data-visible', 'show');
        this.beginBtn.innerHTML = this.beginBtn.getAttribute('data-default-msg');
        this.beginBtn.setAttribute('data-btn-state', 'hidden');
        this.instructionTitle.innerHTML = this.defaultMsg;
        if (buttonStatus) {
            this.resetCompStates(viewerProducts, viewerKeyItems);
        }
        // Timer //
        // reset seconds to start a countdown from 60
        this.seconds = 60;
        this.beginTimer();
        timer = setInterval(() => {
            this.countTimer(timer);
        }, 1000);
        // If on mobile (<=768px), ensure the timer element is visible
        if (window.innerWidth <= 768 && this.timerOutput) {
            try {
                this.viewerImg.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } catch (e) {
                // ignore scroll errors
            }
        }
        // Interaction listeners //
        this.viewer.style.touchAction = 'none';
        const getClient = (ev) => {
            if (ev.type && ev.type.indexOf('touch') === 0) {
                const t = (ev.touches && ev.touches[0]) || (ev.changedTouches && ev.changedTouches[0]);
                return { clientX: t.clientX, clientY: t.clientY };
            }
            return { clientX: ev.clientX, clientY: ev.clientY };
        };
        // Ponter Events to be tied to mouse or touch events //
        this._onPointerDown = (e) => {
            if (!this.isZoomed) return;
            const { clientX, clientY } = getClient(e);
            this.isDragging = true;
            this.viewer.classList.add('tmw-landing-page__competition-viewer--dragging');
            // disable CSS transition during active dragging to avoid jumps
            this._savedTransition = this.viewerImg.style.transition || 'all 0.3s ease';
            this.viewerImg.style.transition = 'none';
            this.dragStart.x = clientX - this.position.x;
            this.dragStart.y = clientY - this.position.y;
        };
        this._onPointerMove = (e) => {
            if (!this.isDragging || !this.isZoomed) return;
            if (e.type && e.type.indexOf('touch') === 0) e.preventDefault();
            const { clientX, clientY } = getClient(e);
            const newX = clientX - this.dragStart.x;
            const newY = clientY - this.dragStart.y;
            this.updatePosition(newX, newY);
        };
        this._onPointerUp = () => {
            this.isDragging = false;
            this.viewer.classList.remove('tmw-landing-page__competition-viewer--dragging');
            // restore image transition after drag finishes
            if (this.viewerImg) {
                this.viewerImg.style.transition = this._savedTransition || '';
                delete this._savedTransition;
            }
        };
        this._onPointerLeave = () => {
            this.isDragging = false;
            this.viewer.classList.remove('tmw-landing-page__competition-viewer--dragging');
            if (this.viewerImg) {
                this.viewerImg.style.transition = this._savedTransition || '';
                delete this._savedTransition;
            }
        };
        // Add click/pointer events either first time or after reset/removal //
        this.resetClickEvents('add');
        // Set active clicks and update found items count, call complete if all found //
        viewerProducts.forEach((itemToFind) => {
            // Remove a previously attached handler (if any) so clicks don't accumulate
            if (itemToFind._compClickHandler) {
                itemToFind.removeEventListener('click', itemToFind._compClickHandler);
                delete itemToFind._compClickHandler;
            }
            // Show Products //
            itemToFind.setAttribute('data-prod-visible', 'active');
            const handler = () => {
                // Ignore clicks on items already marked active to avoid double-counting
                if (itemToFind.getAttribute('data-prod-state') === 'active') return;
                itemToFind.setAttribute('data-prod-state', 'active');
                // Activate next item based on fountitems count and corresponding key item //
                if (viewerKeyItems && viewerKeyItems.length) {
                    const nextIndex = foundItems;
                    const keyToActivate = viewerKeyItems[nextIndex];
                    if (keyToActivate && keyToActivate.getAttribute('data-prod-state') !== 'active') {
                        keyToActivate.setAttribute('data-prod-state', 'active');
                        foundItems++;
                    }
                }
                if (foundItems == parseInt(maxItems, 10)) {
                    this.viewerComplete(timer);
                }
            };
            itemToFind._compClickHandler = handler;
            itemToFind.addEventListener('click', handler);
        });
    }
    // Timer functions -  starts the counter immediately, the other is via timeout, third pauses(success) //
    beginTimer() {
        this.timerOutput.setAttribute('data-timer-status', 'active');
        const mins = Math.floor(this.seconds / 60);
        const secs = this.seconds % 60;
        const minsStr = mins < 10 ? '0' + mins : String(mins);
        const secsStr = secs < 10 ? '0' + secs : String(secs);
        this.timerOutput.innerHTML = minsStr + '.' + secsStr;
    }
    countTimer(timer) {
        if (this.seconds > this.limit) {
            this.seconds--;
            const mins = Math.floor(this.seconds / 60);
            const secs = this.seconds % 60;
            const minsStr = mins < 10 ? '0' + mins : String(mins);
            const secsStr = secs < 10 ? '0' + secs : String(secs);
            this.timerOutput.innerHTML = minsStr + '.' + secsStr;
        } else {
            this.timerOutput.innerHTML = '00.00';
            clearInterval(timer);
            this.viewerTimeUp();
        }
    }
    pauseTimer(timer) {
        this.viewerInstruction.setAttribute('data-viewer-state', 'inactive');
        clearInterval(timer);
    }
    // Position Updates //
    updatePosition(x, y) {
        if (!this.isZoomed) return;
        const baseWidth = this.viewerImg.offsetWidth;
        const baseHeight = this.viewerImg.offsetHeight;
        const scaledWidth = baseWidth * this.scale;
        const scaledHeight = baseHeight * this.scale;
        // Scale w/h minus viewing/container w/h divide by 2 to make sure max drag is in place for both //
        const maxDragX = Math.max(0, (scaledWidth - this.containerWidth) / 2);
        const maxDragY = Math.max(0, (scaledHeight - this.containerHeight) / 2);
        this.position.x = Math.max(-maxDragX, Math.min(maxDragX, x));
        this.position.y = Math.max(-maxDragY, Math.min(maxDragY, y));
        this.viewerImg.style.transform = `translate(${this.position.x}px, ${this.position.y}px) scale(${this.scale})`;
    }
    // Failed //
    viewerTimeUp() {
        this.resetClickEvents('remove');
        this.viewerInstruction.setAttribute('data-viewer-state', 'inactive');
        let failedMsgContent = this.viewer.getAttribute('data-failed-msg');
        this.instructionTitle.innerHTML = failedMsgContent;
        this.querySelector('.tmw-landing-page__competition-description p').setAttribute('data-visible', 'hide');
        this.beginBtn.innerHTML = this.beginBtn.getAttribute('data-fail-msg');
        this.seconds = 0;
        this.beginBtn.setAttribute('data-btn-state', 'show');
        this.beginBtn.setAttribute('data-attempted', 'true');
    }
    // Resets //
    resetCompStates(products, keyProducts) {
        products.forEach((product) => {
            product.setAttribute('data-prod-state', 'inactive');
        });
        keyProducts.forEach((keyProduct) => {
            keyProduct.setAttribute('data-prod-state', 'inactive');
        });
    }
    resetClickEvents(type) {
        if (type == 'remove') {
            if (this.viewerImg) {
                this.viewerImg.style.transition = this._savedTransition || 'all 0.3s ease';
                delete this._savedTransition;
                this.viewerImg.style.transform = `translate(0px, 0px) scale(1.0)`;
                this.viewer.classList.remove('tmw-landing-page__competition-viewer--draggable');
                this.viewerImg.classList.add('tmw-landing-page__competition-viewer--disabled');
            }
            if (window.PointerEvent) {
                if (this._onPointerDown) this.viewer.removeEventListener('pointerdown', this._onPointerDown);
                if (this._onPointerMove) this.viewer.removeEventListener('pointermove', this._onPointerMove);
                if (this._onPointerUp) this.viewer.removeEventListener('pointerup', this._onPointerUp);
                if (this._onPointerLeave) this.viewer.removeEventListener('pointerleave', this._onPointerLeave);
            } else {
                if (this._onPointerDown) this.viewer.removeEventListener('touchstart', this._onPointerDown);
                if (this._onPointerMove) this.viewer.removeEventListener('touchmove', this._onPointerMove);
                if (this._onPointerUp) this.viewer.removeEventListener('touchend', this._onPointerUp);
                if (this._onPointerLeave) this.viewer.removeEventListener('touchcancel', this._onPointerLeave);
                if (this._onPointerDown) this.viewer.removeEventListener('mousedown', this._onPointerDown);
                if (this._onPointerMove) document.removeEventListener('mousemove', this._onPointerMove);
                if (this._onPointerUp) document.removeEventListener('mouseup', this._onPointerUp);
            }
            this._onPointerDown = null;
            this._onPointerMove = null;
            this._onPointerUp = null;
            this._onPointerLeave = null;
            this.viewer.style.touchAction = '';
        } else {
            this.viewer.classList.add('tmw-landing-page__competition-viewer--draggable');
            this.viewerImg.classList.remove('tmw-landing-page__competition-viewer--disabled');
            if (window.PointerEvent) {
                this.viewer.addEventListener('pointerdown', this._onPointerDown);
                this.viewer.addEventListener('pointermove', this._onPointerMove);
                this.viewer.addEventListener('pointerup', this._onPointerUp);
                this.viewer.addEventListener('pointerleave', this._onPointerLeave);
            } else {
                this.viewer.addEventListener('touchstart', this._onPointerDown, { passive: false });
                this.viewer.addEventListener('touchmove', this._onPointerMove, { passive: false });
                this.viewer.addEventListener('touchend', this._onPointerUp);
                this.viewer.addEventListener('touchcancel', this._onPointerLeave);
                this.viewer.addEventListener('mousedown', this._onPointerDown);
                document.addEventListener('mousemove', this._onPointerMove);
                document.addEventListener('mouseup', this._onPointerUp);
            }
        }
    }
    // Competition Viewer Complete //
    viewerComplete(timer) {
        // Stop timer and remove all listeners //
        this.pauseTimer(timer);
        this.resetClickEvents('remove');
        // Ping success states/messages //
        let successMsgContent = this.viewer.getAttribute('data-success-msg');
        let successMsgBtn = this.beginBtn.getAttribute('data-success-msg');
        this.querySelector('.tmw-landing-page__competition-description p').setAttribute('data-visible', 'hide');
        this.instructionTitle.innerHTML = successMsgContent;
        this.beginBtn.remove();
        let continueBtn = document.createElement('button');
        continueBtn.classList.add('button');
        continueBtn.classList.add('competition-continue-btn');
        continueBtn.setAttribute('type', 'button');
        continueBtn.innerText = successMsgBtn;
        this.querySelector('.tmw-landing-page__competition-controls').appendChild(continueBtn);
        // Add listener to new button to show form //
        continueBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.querySelector('.tmw-landing-page__loading-state').setAttribute('data-status', 'active');
            this.querySelector('.tmw-landing-page__competition-butterfly').setAttribute('data-visibility', 'hide');
            setTimeout(() => {
                this.querySelector('.tmw-landing-page__loading-state').setAttribute('data-status', 'inactive');
                this.quizWrap.remove();
                this.formWrap.setAttribute('data-status', 'active');
                window.scrollTo({ top: 300, behavior: 'smooth' });
            }, 2000);
            // Form //
            const successForm = this.formWrap.querySelector('form');
            // Begin Snippet //
            const checkEndpoint = getGlobalDomain('/apps/subscriptions-bat/tomorrowland/check');
            const createCustomerEndpoint = getGlobalDomain('/apps/bat-enhanced/newsletter/subscribe');
            const submitEndpoint = getGlobalDomain('/apps/subscriptions-bat/tomorrowland/submit');
            const checkEmail = async (formData) => {
                const response = await fetch(checkEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        emailAddress: formData.get('emailAddress'),
                    }),
                });
                if (!response.ok) {
                    throw new Error('Failed to check user');
                }
                const data = await response.json();
                return data;
            };
            const createCustomer = async (formData) => {
                const phoneNumberInput = formData.get('mobileNumber');
                const phonePrefix = window.validation[Shopify.country].phone.prefix;
                const phone = phoneNumberInput ? phonePrefix + phoneNumberInput : '';
                const dobInputValue = formData.get('dateOfBirth');
                const parts = dobInputValue.split('/');
                let dobFormatted = '';
                if (parts.length === 3) {
                    dobFormatted = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
                const regexPattern = /^(19|20)\d{2}-\d{2}-\d{2}$/;
                if (!regexPattern.test(dobFormatted)) {
                    console.error('Date format is not right.');
                    throw new Error('Date format is not right.');
                }
                const response = await fetch(createCustomerEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        firstName: formData.get('firstName'),
                        lastName: formData.get('lastName'),
                        email: formData.get('emailAddress'),
                        consent: {
                            email:
                                formData.get('consent.marketing') === 'on' ||
                                formData.get('consent.marketing') === 'true',
                            sms: false,
                        },
                        phone: phone,
                        competitionTag: 'tomorrowland26',
                        dob: dobFormatted,
                    }),
                });
                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || 'Failed to create account');
                }
                const data = await response.json();
                if (!data.ok) {
                    throw new Error(data.message || 'Failed to create account');
                }
                return data;
            };
            const submit = async (formData) => {
                const phoneNumberInput = formData.get('mobileNumber');
                const phonePrefix = window.validation[Shopify.country].phone.prefix;
                const phone = phoneNumberInput ? phonePrefix + phoneNumberInput : '';
                const dobInputValue = formData.get('dateOfBirth');
                const parts = dobInputValue.split('/');
                let dobFormatted = '';
                if (parts.length === 3) {
                    dobFormatted = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
                const regexPattern = /^(19|20)\d{2}-\d{2}-\d{2}$/;
                if (!regexPattern.test(dobFormatted)) {
                    console.error('Date format is not right.');
                    throw new Error('Date format is not right.');
                }
                const response = await fetch(submitEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        customerId: '',
                        firstName: formData.get('firstName'),
                        lastName: formData.get('lastName'),
                        emailAddress: formData.get('emailAddress'),
                        dateOfBirth: dobFormatted,
                        mobileNumber: phone,
                        newsletterSignup:
                            formData.get('consent.marketing') === 'on' || formData.get('consent.marketing') === 'true',
                        quizComplete: false,
                        quizCorrectAnswers: null,
                        instagramHandle: null,
                    }),
                });
                if (!response.ok) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || 'Failed to submit entry');
                }
                const data = await response.json();
                if (!data.ok) {
                    throw new Error(data.message || 'Failed to submit entry');
                }
                return data;
            };
            successForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                const formData = new FormData(successForm);
                const formSpinner = successForm.querySelector('.generic-form__spinner');
                const formErrors = successForm.querySelector('.global-message');
                // Translations //
                const msgError = successForm.querySelector('.form-field__translations').dataset.generror;
                const msgPhoneConflict = successForm.querySelector('.form-field__translations').dataset.phoneconflict;
                const mesPrevEntry = successForm.querySelector('.form-field__translations').dataset.prevsub;
                const msgRequired = successForm.querySelector('.form-field__translations').dataset.required;
                // Clear any previous errors
                formErrors.classList.remove('global-message--active');
                formSpinner.classList.remove('hidden');
                // Ensure all required fields have a value before attempting submission
                const requiredFields = Array.from(successForm.querySelectorAll('[required]'));
                const missing = requiredFields.filter((field) => {
                    const value = formData.get(field.name);
                    return value === null || value === undefined || String(value).trim() === '';
                });
                if (missing.length) {
                    formSpinner.classList.add('hidden');
                    formErrors.classList.add('global-message--active');
                    formErrors.innerHTML = msgRequired;
                    return;
                }
                try {
                    const check = await checkEmail(formData);

                    // Only proceed with submission if email doesn't exist
                    if (!check.exists) {
                        const submission = await submit(formData);

                        // Bail out if submission wasn't recorded
                        if (submission.recorded !== true) {
                            formSpinner.classList.add('hidden');
                            formErrors.classList.add('global-message--active');
                            formErrors.innerHTML = submission.exists ? mesPrevEntry : msgError;
                            return;
                        }

                        // Only create customer if they've given consent
                        const hasConsent =
                            formData.get('consent.marketing') === 'on' || formData.get('consent.marketing') === 'true';

                        if (hasConsent) {
                            await createCustomer(formData);
                        }

                        // Show success
                        setTimeout(() => {
                            successForm.remove();
                            document.querySelector('.tmw-landing-page__banner').remove();
                            document.querySelector('.tmw-landing-page__end-mountains').remove();
                            let successTitle = this.formWrap
                                .querySelector('.tmw-success-form__form-titles h2')
                                .getAttribute('data-success');
                            this.formWrap.setAttribute('data-completion', 'complete');
                            this.formWrap.querySelector('.tmw-success-form__form-titles h2').innerHTML = successTitle;
                            window.scrollTo({ top: 50, behavior: 'smooth' });
                        }, 1000);
                    } else {
                        // Customer has already entered
                        formSpinner.classList.add('hidden');
                        formErrors.classList.add('global-message--active');
                        formErrors.innerHTML = mesPrevEntry;
                    }
                } catch (error) {
                    formSpinner.classList.add('hidden');
                    formErrors.classList.add('global-message--active');
                    if (error.message === 'phone-conflict') {
                        formErrors.innerHTML = msgPhoneConflict;
                    } else {
                        formErrors.innerHTML = msgError;
                    }
                    if (error.message) {
                        console.error(error.message);
                    }
                }
            });
        });
    }
}
customElements.define('competition-viewer', CompetionViewer);
